import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { ILabel } from 'utils/types/contentful';
import clsx from 'clsx';
import { CompareAtPrice } from './CompareAt/compareAtPrice';

export interface ProductPriceProps {
  type?: any;
  size?: string;
  currency: ILabel;
  price: ILabel;
  compareAtPrice?: ILabel;
  isBadge: boolean;
  onClick?: () => void;
}

const returnSizeVariant = (size: string) => {
  switch (size) {
    case 'sm':
      return 'py-0.5 px-2';
    case 'base':
      return 'py-1 px-3';
    case 'lg':
      return 'py-2 px-4';
    default:
      return 'py-1 px-3';
  }
};

const returnCurrencySize = (size: string) => {
  switch (size) {
    case 'sm':
      return 'xs';
    case 'lg':
      return 'sm';
    case 'xl':
      return 'base';
    case '2xl':
      return 'xl';
    case '3xl':
      return '2xl';
    case '4xl':
      return '3xl';
    case '5xl':
      return '4xl';
    default:
      return 'py-1 px-3';
  }
};

export const ProductPrice: React.FC<ProductPriceProps> = ({
  compareAtPrice,
  currency,
  isBadge,
  price,
  productCategory,
  size,
}) => {
  return (
    <div className='flex justify-end'>
      <div
        className={clsx(
          'hover:text-black animate ease-in-out',
          compareAtPrice && 'mr-2',
          {
            [`rounded-full bg-white border flex justify-center items-end ${returnSizeVariant(
              size
            )}`]: isBadge,
          }
        )}>
        <Label
          type='span'
          text={price.text}
          color={{ classname: 'gray-800' }}
          size={size}
        />
        <Label
          type='span'
          color={productCategory?.color}
          size={returnCurrencySize(size)}
          weight='medium'
          text={currency.text}
        />
      </div>
      {compareAtPrice && (
        <CompareAtPrice
          productCategory={productCategory}
          compareAtPrice={compareAtPrice}
          currency={currency}
        />
      )}
    </div>
  );
};
